export default __webpack_public_path__ + "static/media/Aru.fc28982f.png";